module.exports = "/images/vendor/flag-icon-css/flags/4x3/ch.svg?9c26f60a63bf575c6b7be3eec11e3043";